/**
 * 🔧 BUILDING SPECIALIZATIONS
 *
 * Each building can be upgraded to ONE path (permanent choice).
 * Specializations provide production multipliers and additional production.
 */

export const SPECIALIZATIONS = {
  // WOODCUTTER specializations
  woodcutter: [
    {
      id: 'woodcutter_lumber',
      name: 'Lumber Mill',
      icon: '🏭',
      description: 'Industrial wood processing',
      effect: '+100% wood production',
      multiplier: { wood: 2.0 },
      cost: { gold: 50, iron: 25 },
      consumes: null,
    },
    {
      id: 'woodcutter_sanctuary',
      name: 'Forest Sanctuary',
      icon: '🌲',
      description: 'Sustainable forestry',
      effect: '+50% wood, +produces culture',
      multiplier: { wood: 1.5 },
      addProduction: { culture: 0.1 },
      cost: { gold: 75, knowledge: 25 },
      consumes: null,
    },
    {
      id: 'woodcutter_charcoal',
      name: 'Charcoal Kiln',
      icon: '🔥',
      description: 'Convert wood to fuel',
      effect: '+30% wood, +produces coal',
      multiplier: { wood: 1.3 },
      addProduction: { coal: 0.15 },
      cost: { stone: 50, iron: 25 },
      consumes: null,
    },
  ],

  // QUARRY specializations
  quarry: [
    {
      id: 'quarry_deep',
      name: 'Deep Quarry',
      icon: '⛏️',
      description: 'Dig deeper for more stone',
      effect: '+120% stone production',
      multiplier: { stone: 2.2 },
      cost: { gold: 75, iron: 50 },
      consumes: null,
    },
    {
      id: 'quarry_gems',
      name: 'Gem Excavation',
      icon: '💎',
      description: 'Search for precious gems',
      effect: '+50% stone, +produces gems',
      multiplier: { stone: 1.5 },
      addProduction: { gems: 0.05 },
      cost: { gold: 150, tools: 25 },
      consumes: null,
    },
    {
      id: 'quarry_marble',
      name: 'Marble Works',
      icon: '🏛️',
      description: 'Extract fine marble',
      effect: '+30% stone, +produces culture',
      multiplier: { stone: 1.3 },
      addProduction: { culture: 0.15 },
      cost: { gold: 100, knowledge: 50 },
      consumes: null,
    },
  ],

  // FARM specializations
  farm: [
    {
      id: 'farm_industrial',
      name: 'Industrial Farm',
      icon: '🚜',
      description: 'Mechanized agriculture',
      effect: '+150% food production',
      multiplier: { food: 2.5 },
      cost: { gold: 100, tools: 50 },
      consumes: null,
    },
    {
      id: 'farm_orchard',
      name: 'Royal Orchard',
      icon: '🍎',
      description: 'Grow luxury produce',
      effect: '+50% food, +produces gold',
      multiplier: { food: 1.5 },
      addProduction: { gold: 0.2 },
      cost: { gold: 150, wood: 100 },
      consumes: null,
    },
    {
      id: 'farm_herbs',
      name: 'Herb Garden',
      icon: '🌿',
      description: 'Cultivate magical herbs',
      effect: '+30% food, +produces magic',
      multiplier: { food: 1.3 },
      addProduction: { magic: 0.05 },
      cost: { gold: 200, knowledge: 75 },
      consumes: null,
    },
  ],

  // MINE specializations
  mine: [
    {
      id: 'mine_deep',
      name: 'Deep Mine',
      icon: '⬇️',
      description: 'Dig to the depths',
      effect: '+100% iron production',
      multiplier: { iron: 2.0 },
      cost: { gold: 150, steel: 50 },
      consumes: null,
    },
    {
      id: 'mine_efficient',
      name: 'Efficient Mine',
      icon: '⚙️',
      description: 'Better extraction methods',
      effect: '+60% iron, +produces coal',
      multiplier: { iron: 1.6 },
      addProduction: { coal: 0.1 },
      cost: { gold: 200, tools: 50 },
      consumes: null,
    },
    {
      id: 'mine_precious',
      name: 'Precious Metals',
      icon: '✨',
      description: 'Search for gold veins',
      effect: '+40% iron, +produces gold',
      multiplier: { iron: 1.4 },
      addProduction: { gold: 0.3 },
      cost: { gold: 300, gems: 10 },
      consumes: null,
    },
  ],

  // LIBRARY specializations
  library: [
    {
      id: 'library_archive',
      name: 'Grand Archive',
      icon: '📖',
      description: 'Vast knowledge repository',
      effect: '+100% knowledge production',
      multiplier: { knowledge: 2.0 },
      cost: { gold: 200, culture: 50 },
      consumes: null,
    },
    {
      id: 'library_academy',
      name: 'Royal Academy',
      icon: '🎓',
      description: 'Train scholars',
      effect: '+50% knowledge, +produces science',
      multiplier: { knowledge: 1.5 },
      addProduction: { science: 0.1 },
      cost: { gold: 300, culture: 100 },
      consumes: null,
    },
    {
      id: 'library_arcane',
      name: 'Arcane Library',
      icon: '📜',
      description: 'Study forbidden texts',
      effect: '+30% knowledge, +produces magic',
      multiplier: { knowledge: 1.3 },
      addProduction: { magic: 0.1 },
      cost: { gold: 250, gems: 25 },
      consumes: null,
    },
  ],
};

export default SPECIALIZATIONS;
